import dispatcher from '../dispatcher';
import axios, {AxiosError} from 'axios';
import { ItemCart, OrderDelayTypePrice } from './iCart';
import {getHostApi, getRequestConfig, getRequestConfigForFetch} from "../../utils";

/**
 * Fonction qui créer un panier
 */
export function createCart() {
  return axios.post(`${getHostApi()}/carts/`, {}, getRequestConfig()).then((res) => {
    if(res.data.cart) {
      localStorage.setItem('cartStruct', JSON.stringify(res.data));
      dispatcher.dispatch({
        type: 'REFRESH_CART',
        value: res.data.cart
      });
    }
  });
}

/**
 * Fonction permettant de récupérer le panier
 */
export function getCart() {
  if (!getCartId()) {
    return;
  }
  const i18nLangStr = localStorage.getItem('i18nLang');
  let idLang = 1;
  if (i18nLangStr) {
    const i18nLangObj = JSON.parse(i18nLangStr);
    idLang = i18nLangObj.id;
  }
  const countryDelivery = localStorage.getItem('countryDelivery');
  let countryCode = 'FR';
  if (countryDelivery) {
    countryCode = countryDelivery;
  }

  return axios.get(`${getHostApi()}/carts/${getCartId()}`, {...getRequestConfig(), params: {idLang, countryCode}}).then((response) => {
    if (response.data.cart) {
      localStorage.setItem('cartStruct', JSON.stringify(response.data));
      dispatcher.dispatch({
        type: 'REFRESH_CART',
        value: response.data.cart,
      });
    }
  });
}

/**
 * Fonction permettant de supprimer l'item d'un panier
 * @param itemId
 */
export function removeItemCart(itemId: string) {
  axios.delete(`${getHostApi()}/carts/${getCartId()}/items/${itemId}`, getRequestConfig()).then((response) => {
    getCart();
  }).catch((error: AxiosError) => {
    if (error?.response?.status === 400 && error?.response?.data?.message) {
      alert(error.response.data.message);
    } else {
      console.log(error);
    }
  });
}

/**
 * Fonction permettant de vider le panier
 */
export function clearCart() {
  axios.delete(`${getHostApi()}/carts/${getCartId()}`, getRequestConfig()).then((response) => {
    getCart();
  }).catch((error) => {
    console.log(error);
  });
}

/**
 * Permet d'ajouter un tableau d'article dans le panier
 * @param items
 */
export function createItems(items: any[]) {
  axios.post(`${getHostApi()}/carts/${getCartId()}/items`, items, getRequestConfig()).then((res) => {
    getCart();
  }).catch((err) => {
    console.log(err);
  });
}

/**
 * Permet d'ajouter un tableau d'article dans le panier
 * @param items
 */
export function addItemsToCart(items: any[]): Promise<void> {
  return axios.post(`${getHostApi()}/carts/${getCartId()}/items`, items, getRequestConfig()).then((res) => {
    getCart();
  }).catch((err) => {
    console.log(err);
  });
}

/**
 * Permet d'ajouter un article dans le panier
 * @param items
 */
export function addItemToCart(item: any): Promise<any> {
  return axios.post(`${getHostApi()}/carts/${getCartId()}/items/`, item, getRequestConfig()).then((res) => {
    return res.data;
  }).catch((err) => {
    console.log(err);
  });
}



/**
 * Fonction permettant de mettre à jour le panier
 * @param data
 */
export async function updateCart(data: Record<string, unknown>, signal?: AbortSignal): Promise<unknown> {
  let response = null;
  try {
    const config = getRequestConfigForFetch(signal);
    config.headers = { ...config.headers, 'Content-Type': 'application/json' };
    response = await fetch(`${getHostApi()}/carts/${getCartId()}`, {
      ...config,
      method: 'PUT',
      body: JSON.stringify(data)
    });
  } catch (err) {
    if (signal === undefined || !signal.aborted) {
      throw err;
    }
  }

  if (response !== null && response.status >= 400) {
    throw new Error('Un problème est survenu');
  }

  return response?.json().then((response) => {
    if (typeof response.cart === 'object') {
      dispatcher.dispatch({
        type: 'REFRESH_CART',
        value: response.cart,
      });
    } else {
      throw response.cart;
    }
  });
}

/**
 * Fonction permettant de mettre à jour un item de panier
 * @param data
 * @param itemId
 */
export async function updateItemCart(data: Record<string, unknown>, itemId: string) {
  const res = await axios.put(`${getHostApi()}/carts/${getCartId()}/items/${itemId}`, data, getRequestConfig());
  if(res.status === 400 && res.data.message) {
    alert(res.data.message);
  }
  return await getCart();
}

/**
 * Fonction permettant de récupérer le cart id dans le localstorage
 */
export function getCartId() {
  const storageCart = localStorage.getItem('cartStruct');
  if (storageCart) {
    const cart = JSON.parse(storageCart);
    if (cart && cart.cart.id) {
      return cart.cart.id;
    }
  }
}

/**
 * @deprecated
 * Fonction permettant de récuperer le x-xsrf-token
 */
export function getHeadersToken() {
  return {
    'x-xsrf-token': localStorage.getItem('xsrfToken'),
  };
}

/**
 * Fonction permettant de récupérer les infos de la boutique
 */
export function getShopInfos(): Promise<void> {
  return axios.get(`${getHostApi()}/shops/infos`, getRequestConfig()).then((response) => {
    if (response.data.shopInfos) {
      sessionStorage.setItem('shopInfos', JSON.stringify(response.data.shopInfos));
    }
  }).catch((error) => {
    console.log(error);
  });
}

export function applyShare(token: string): Promise<unknown> {
  return axios.post(`${getHostApi()}/carts/${getCartId()}/share/apply`, {
    shareToken: token,
  }, getRequestConfig()).then((response) => {
    localStorage.setItem('cartStruct', JSON.stringify(response.data));
    dispatcher.dispatch({
      type: 'REFRESH_CART',
      value: response.data.cart,
    });
  }).catch((error) => {
    console.log(error);
  });
}

export function getUrlParameter(field: string, url?: string) {
  const href = url ? url : window.location.href;
  const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  const string = reg.exec(href);
  return string ? string[1] : null;
}

export function updatePiwik() {
  const date = new Date();
  const cartStruct = JSON.parse(localStorage.getItem('cartStruct') as any);
  const shopInfo = JSON.parse(sessionStorage.getItem('shopInfos') as any);

  let customerStruct: any;
  let index: string;
  const items: any[] = [];
  let item: ItemCart;
  const quantites: any = {};
  const myitems: any = {};

  for (item of cartStruct.cart.items) {
    if (!quantites['A' + item.article.idArticles]) {
      quantites['A' + item.article.idArticles] = 0;
    }

    quantites['A' + item.article.idArticles] += parseInt(item.quantite + '');
    myitems['A' + item.article.idArticles] = [
      item.article.idArticles,
      item.article.produit.Titre + ' ' + item.article.couleur.Couleur + ' ' + item.article.taille.Taille,
      '',
      item.pu_ht,
      quantites['A' + item.article.idArticles],
    ];
  }

  for (index in myitems) {
    items.push(myitems[index]);
  }

  const dataPiwik: any = {idsite: shopInfo.matomo_id,
    rec: 1,
    rand: Date.now(),
    apiv: 1,
    res: window.screen.availWidth + 'x' + window.screen.availHeight,
    h: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
    idgoal: 0,
    ec_items: JSON.stringify(items),
  };

  try {
    customerStruct = JSON.parse(sessionStorage.getItem('customerStruct') as any);
    dataPiwik.uid = customerStruct?.idClient;
  } catch (e) {
    console.error(e);
  }

  axios.get('https://piwik.designpartner.fr/piwik.php', {
    params: dataPiwik,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  }).catch((err) => {
    console.error(err);
  });
}

export async function calculatePriceFromOrderDelayType(countryCode: string, calculatePort: boolean, signal?: AbortSignal): Promise<OrderDelayTypePrice[]> {
  const addonQuery = calculatePort ? '&calculatePort=1' : '';
  const response = await fetch(`${getHostApi()}/carts/${getCartId()}/order-delay-types?cartPrices=1&countryCode=${countryCode}${addonQuery}`, {
    ...getRequestConfigForFetch(signal),
    method: 'POST'
  });

  if (response.status >= 400) {
    throw new Error('Un problème est survenu');
  }

  return response.json();
}
